// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { MonevDetailResponse } from "./types";

import * as monevActions from "./monev.actions";

export function* getDetail(
  action: ReturnType<typeof monevActions.getDetailAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + `monev/${action.payload.MONEV_ID}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: MonevDetailResponse = yield call(result.json.bind(result));
      parsed.data.PESERTA_KEGIATAN = parsed.data.PESERTA_KEGIATAN.replace(/<br\s*[\/]?>/gi, '\n');
      yield put(monevActions.getDetailAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(monevActions.getDetailAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(monevActions.getDetailAsync.failure(parsed));
  }
}

export default function* monevSagaGetDetail() {
  yield takeEvery(monevActions.getDetailAsync.request, getDetail);
}
